import { createI18n } from 'vue-i18n'
import zhCN from './zh-CN.js'
import zhTW from './zh-TW.js'
import enUS from './en-US.js'

// 默认使用繁体，除非用户手动切换
const savedLang = localStorage.getItem('h5im_lang')
const defaultLocale = savedLang || 'zh-CN'

export const i18n = createI18n({
  legacy: false,
  locale: defaultLocale,
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    'zh-TW': zhTW,
    'en-US': enUS
  }
})

export function setLocale(lang) {
  i18n.global.locale.value = lang
  localStorage.setItem('h5im_lang', lang)
  document.documentElement.lang = lang
}

export default i18n
